import jwt from "jsonwebtoken";

export function authChecker(token) {
  if (token) {
    let auth = false;
    const decodedToken = jwt.decode(token, { complete: true });
    const todayDate = new Date().getTime();
    const tokenExpDate = decodedToken.payload.exp * 1000;
    if (tokenExpDate < todayDate) {
      auth = false;
    } else auth = true;
    return auth;
  } else return false;
}
